import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setAuth } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { Loader2, Printer } from "lucide-react";

export default function Setup() {
  const nav = useNavigate();
  const [checking, setChecking] = useState(true);
  const [f, setF] = useState({
    firma_name: "Die Druckexperten",
    admin_email: "",
    admin_vorname: "",
    admin_nachname: "",
    admin_passwort: "",
    admin_passwort_confirm: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/setup/status");
        if (!r.data.setup_needed) nav("/login", { replace: true });
      } catch (e) {}
      setChecking(false);
    })();
     
  }, []);

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.admin_passwort !== f.admin_passwort_confirm) {
      toast.error("Passwörter stimmen nicht überein.");
      return;
    }
    setLoading(true);
    try {
      const r = await api.post("/setup", f);
      setAuth(r.data.access_token, r.data.user);
      toast.success("Einrichtung erfolgreich. Willkommen!");
      nav("/dashboard", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Einrichtung fehlgeschlagen.");
    } finally { setLoading(false); }
  };

  if (checking) return <div className="min-h-screen flex items-center justify-center text-slate-500">Lade…</div>;

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <Card className="w-full max-w-lg shadow-lg border-slate-200" data-testid="setup-card">
        <CardHeader className="text-center space-y-3 pb-4">
          <div className="mx-auto w-12 h-12 rounded-xl bg-blue-600 flex items-center justify-center">
            <Printer className="w-6 h-6 text-white" />
          </div>
          <CardTitle className="text-2xl font-bold tracking-tight">Ersteinrichtung</CardTitle>
          <p className="text-sm text-slate-500">Legen Sie Ihr Unternehmen und den Administrator-Zugang an.</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4" data-testid="setup-form">
            <div>
              <Label htmlFor="firma">Firmenname</Label>
              <Input id="firma" required value={f.firma_name} onChange={set("firma_name")} data-testid="setup-firma-input" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <Label htmlFor="vorname">Vorname</Label>
                <Input id="vorname" required value={f.admin_vorname} onChange={set("admin_vorname")} data-testid="setup-vorname-input" />
              </div>
              <div>
                <Label htmlFor="nachname">Nachname</Label>
                <Input id="nachname" required value={f.admin_nachname} onChange={set("admin_nachname")} data-testid="setup-nachname-input" />
              </div>
            </div>
            <div>
              <Label htmlFor="email">E-Mail (Administrator)</Label>
              <Input id="email" type="email" required value={f.admin_email} onChange={set("admin_email")} data-testid="setup-email-input" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <Label htmlFor="pw">Passwort</Label>
                <Input id="pw" type="password" required minLength={6} value={f.admin_passwort} onChange={set("admin_passwort")} data-testid="setup-passwort-input" />
              </div>
              <div>
                <Label htmlFor="pw2">Passwort bestätigen</Label>
                <Input id="pw2" type="password" required minLength={6} value={f.admin_passwort_confirm} onChange={set("admin_passwort_confirm")} data-testid="setup-passwort-confirm-input" />
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full" data-testid="setup-submit-button">
              {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
              Einrichtung abschließen
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
